import type { EntityState } from '@core/ngrx-legacy';
import { createEntityCollectionStore } from '@core/ngrx-legacy';
import type { ReportDashboardMetricOptions } from '@core/reports-types';

import { safeReportsStateSelector } from '../helpers/safe-selector';

const namespace = 'ReportsMetrics';

const { actions, selectors, reducer, initialState } =
  createEntityCollectionStore<ReportDashboardMetricOptions>()(namespace, {
    baseSelector: (root): EntityState<ReportDashboardMetricOptions> =>
      safeReportsStateSelector(root, namespace, initialState),
    idSelector: (metric: ReportDashboardMetricOptions) => metric.metric,
    customActions: adapter => ({
      resetAll: state => adapter.resetAll(state),
    }),
  });

export {
  actions as ReportsMetricsActions,
  namespace as ReportsMetricsNamespace,
  reducer as ReportsMetricsReducer,
  selectors as ReportsMetricsSelectors,
};
